import React, { useEffect, useRef, useState } from "react";
import ssoHandler from "../ssoHandler";
import env from "../../config";
import LoadingScreen from "../../components/LoadingScreen";
import IframeSendData from "../../helper/IframeSendData";

const AppIframe = () => {
  const { SSO, checkSSO } = ssoHandler();
  const [ssodata, setssodata] = useState({});
  const [iframeUrl, setIframeUrl] = useState("");
  const [loader, setloader] = useState(true);

  useEffect(() => {
    checkSSO();
  }, []);

  useEffect(() => {
    if (SSO != "" && SSO != undefined) {
      var data = JSON.parse(SSO);
      let url = `${env.APP_URL}/${data.companyId}/dashboard`;
      if (data?.activeLocation) {
        url = `${env.APP_URL}/account/${data.companyId}/${data.activeLocation}/dashboard`;
      }
      setssodata(data);
      setIframeUrl(url);
      setloader(false);
    }
  }, [SSO]);
  if (loader) {
    return <LoadingScreen loadingText={"Loading data..."} />;
  }
  return (
    <div>
      <IframeSendData SSOData={ssodata} iframeUrl={iframeUrl} />
    </div>
  );
};

export default AppIframe;
